import { ClinicBoard } from "@board/ClinicBoard";
import { useDialog } from "@scribenote/brian-design-system";
import type { ReactNode } from "react";

const BOARD_ZOOM = 0.6;

// Hoisted, so the room's once-a-second re-render skips the board.
const BOARD = <ClinicBoard readOnly />;

/**
 * One room over the whole viewport, with a small read-only clinic board
 * underneath. A modal `<dialog>` rather than a fixed layer: the room's own
 * dialogs stack above it, the page behind goes inert, and Escape closes it.
 */
export const RoomFullScreen = ({
  roomName,
  onClose,
  children,
}: {
  roomName: string;
  onClose: () => void;
  children: ReactNode;
}) => {
  const { dialogRef } = useDialog({ open: true, onClose });
  return (
    <dialog
      ref={dialogRef}
      aria-label={`${roomName}, full screen`}
      className="m-0 h-dvh max-h-none w-dvw max-w-none overflow-hidden bg-wall p-0 font-body text-ink-body open:flex"
    >
      {/* The only child, so useDialog's backdrop hit-test measures all of it. */}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        {children}
        <section
          aria-label="Clinic board"
          className="h-[30vh] shrink-0 overflow-auto border-t border-rule px-4 py-2"
        >
          <div style={{ zoom: BOARD_ZOOM }}>{BOARD}</div>
        </section>
      </div>
    </dialog>
  );
};
